<div class="container demo">
    <label class="title-dashboard">Các nhóm chủ đề Bilet</label>
    <div class="carousel slide">
        <div class="row">
            <div class="col-12 col-sm-6 col-md-4 col-lg-3" *ngFor="let item of arrBook" [routerLink]=" item.routerLink"
                [queryParams]="item.queryParams">
                <div class="card" [style.background-image]="'url(' + item.background + ')'">
                    <img class="card-img-top img-fluid" [src]="item.url" width="50" height="50" alt="Card image cap" />
                    <div class="card-body">
                        <div class="card-title">{{ item.category }}</div>
                        <p class="card-text">{{ item.info }}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>